import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { Grid, Image, List, Segment } from 'semantic-ui-react'

import FooterComponent from '../../gallery/components/FooterComponent'
import '../../../node_modules/semantic-ui-css/components/grid.css'
import '../../../node_modules/semantic-ui-css/components/image.css'
import '../../../node_modules/semantic-ui-css/components/icon.css'
import '../../../node_modules/semantic-ui-css/components/list.css'
import '../../../node_modules/semantic-ui-css/components/segment.css'

import AsyncImage from '../../asyncImages/AsyncImage'
import closeIcon from '../../images/close.png'

export default class PersonDetails extends Component {
  static propTypes = {
    cachePerson: PropTypes.func.isRequired,
    loaded: PropTypes.bool.isRequired,
    loadData: PropTypes.func.isRequired,
    person: React.PropTypes.shape({
      description: PropTypes.string.isRequired,
      githubName: PropTypes.string,
      icon: PropTypes.string.isRequired,
      iconAlt: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      photo: PropTypes.string.isRequired,
      site2Title: PropTypes.string,
      site2Url: PropTypes.string,
      siteTitle: PropTypes.string,
      siteUrl: PropTypes.string,
      slug: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      twitterHandle: PropTypes.string,
    }),
  }

  componentWillMount () {
    const { loaded, loadData } = this.props
    if (!loaded) {
      loadData()
    }
  }

  componentDidMount () {
    this.rememberPerson()
  }

  rememberPerson () {
    const { cachePerson, person } = this.props
    if (person && person.slug) {
      cachePerson(person.slug)
    }
  }

  renderListItem (icon, url, text) {
    return (
      <List.Item>
        <List.Icon name={icon} size='large' />
        <List.Content><a href={url}>{text}</a></List.Content>
      </List.Item>
    )
  }

  renderInner () {
    if (this.props.person != null) {
      const {
        description, githubName, icon, iconAlt, name, photo,
        site2Title, site2Url, siteTitle, siteUrl, twitterHandle,
      } = this.props.person
      return (
        <Grid verticalAlign='middle' stackable columns={2}>
          <Grid.Row stretched>
            <Grid.Column>
              <AsyncImage
                alt={name}
                className='ui image'
                cssQualifier='personPhoto'
                loaderSize='massive'
                src={photo}
              />
            </Grid.Column>
            <Grid.Column textAlign='justified'>
              <div className='center top-margin'>
                <h1>{name}</h1>
              </div>
              <div className='center top-margin top-margin-desktop'>
                <Image alt={iconAlt} src={icon} inline />
                <span> {iconAlt}</span>
              </div>
              <div className='top-margin top-margin-desktop'>
                <p>{description}</p>
                <List>
                  {siteUrl && siteTitle
                    && this.renderListItem('world', siteUrl, siteTitle)}
                  {site2Url && site2Title
                    && this.renderListItem('world', site2Url, site2Title)}
                  {githubName
                    && this.renderListItem(
                      'github',
                      `https://github.com/${githubName}`,
                      'GitHub Account')}
                  {twitterHandle
                    && this.renderListItem(
                      'twitter',
                      `https://twitter.com/${twitterHandle}`,
                      'Twitter Account')}
                </List>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )
    }
  }

  render () {
    return (
      <div>
        <Grid centered className='personDetailsGridMargin'>
          <Segment className='margin2em'>
            <Image
              alt='close'
              as={Link}
              avatar
              className='hvr-grow-personDetails-icons'
              floated='right'
              id='close-icon'
              src={closeIcon}
              to='/gallery'
            />
            {this.renderInner()}
          </Segment>
        </Grid>
        <FooterComponent />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/PersonDetailsComponent.js